module.exports = __webpack_public_path__ + "static/media/ic_menu.5dcfe582.svg";